import client from './client';

export const listTotalOrders = (params) => client.get('/total-orders', { params }).then((r) => r.data);
export const summaryTotalOrders = (month) =>
  client.get('/total-orders/summary', { params: { month } }).then((r) => r.data);
export const monthlyTotalOrders = () => client.get('/total-orders/monthly').then((r) => r.data);
